import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import Styles from './index.scss'

function formatStatus(fieldValue, reference) {
  const value = reference.length && reference.filter(r => r.value === fieldValue)[0]
  return <div dangerouslySetInnerHTML={{ __html: value.label || '' }} />
}

const FinanceProfileSection = props => (
  <div className="portlet light">
    <div className="portet-title">
      <h4>Finance Profile</h4>
    </div>
    <div className="portlet-body">
      <div className="row">
        <div className="table-scrollable table-scrollable-borderless">
          <table className="table table-hover table-light">
            <tbody>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Reviewed By</td>
                <td>{ props.dataFinance.reviewedBy ? props.dataFinance.reviewedBy.email : '-'}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Address</td>
                <td>
                  {props.isUpdated && (
                    <div className={`${Styles['text-notif']} ${Styles.success}`}>
                      Updated Address Success
                    </div>
                  )}
                  {props.isUpdatedError && (
                    <div className={`${Styles['text-notif']} ${Styles.failed}`}>
                      Updated Address Failed
                    </div>
                  )}
                  <textarea
                    className={Styles['text-address']}
                    type="text"
                    value={props.dataFinance.address}
                    onChange={props.onChangeAddress}
                  />
                  <button
                    className={Styles['btn-save']}
                    onClick={props.onSaveAddress(props.dataFinance.id, props.dataFinance.address)}
                  >
                    Save
                  </button>
                </td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Is Notified</td>
                <td>{String(props.dataFinance.isNotified)}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Status</td>
                <td>{props.dataFinance.status}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Notified</td>
                <td>{String(props.dataFinance.notified)}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Created At</td>
                <td>{moment(props.dataFinance.createdAt).format('DD MMMM YYYY')}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Updated At</td>
                <td>{moment(props.dataFinance.updatedAt).format('DD MMMM YYYY')}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Company Legal Name</td>
                <td>{props.dataFinance.companyLegalName}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Tax Number</td>
                <td>{props.dataFinance.taxNumber}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Pic Name</td>
                <td>{props.dataFinance.picName}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Pic Number</td>
                <td>{props.dataFinance.picPhone}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Pic Email</td>
                <td>{props.dataFinance.picEmail}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Tax Url</td>
                <td>
                  <a
                    href={props.dataFinance.taxUrl} rel="noopener noreferrer" target="_blank"
                  >
                    View
                  </a>
                </td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Reject Reason</td>
                <td>{ props.dataFinance.rejectReason !== undefined ? formatStatus(props.dataFinance.rejectReason, props.reference) : '-'}</td>
              </tr>
              <tr>
                <td width="400" style={{ textTransform: 'capitalize' }}>Reviewed At</td>
                <td>{ props.dataFinance.reviewedAt ? moment(props.dataFinance.reviewedAt).format('DD MMMM YYYY : hh:mm:ss') : '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {(props.action && props.actionOnChange) && (
      <form
        onSubmit={props.action(
          props.actionParam.id,
          props.actionParam.selectedValue,
          props.actionParam.orderId,
          props.actionParam.selectedReason,
        )}
      >
        <div className="mt-radio-list">
          <label htmlFor="approve" className="mt-radio mt-radio-outline"> Approve
            <input
              onChange={props.actionOnChange(props.actionParam.approvedValue)}
              required
              type="radio"
              value="approved"
              id="approve"
              name="status"
              checked={props.actionParam.selectedValue === props.actionParam.approvedValue}
            />
            <span />
          </label>
          <label htmlFor="reject" className="mt-radio mt-radio-outline"> Reject
            <input
              onChange={props.actionOnChange(props.actionParam.rejectedValue)}
              required
              type="radio"
              value="rejected"
              id="reject"
              name="status"
              checked={props.actionParam.selectedValue === props.actionParam.rejectedValue}
            />
            <span />
          </label>
        </div>
        {
          props.actionParam.selectedValue === props.actionParam.rejectedValue
          ? (
            <div>
              <p>Select Reason:</p>
              <div className="mt-radio-list">
                {
                  props.reference.map(reason => (
                    <div key={reason.value}>
                      <label
                        htmlFor="statusReject"
                      >
                        <input
                          onChange={props.actionOnChangeReason(reason.value)}
                          required
                          type="radio"
                          value={reason.value}
                          id={reason.value}
                          name="statusReject"
                          checked={
                            props.actionParam.selectedReason === reason.value
                          }
                        />
                        <h9
                          onClick={props.actionOnChangeReason(reason.value)}
                          style={{
                            margin: '20px',
                          }}
                        >
                          {reason.label}
                        </h9>
                      </label>
                    </div>
                  ))
                }
              </div>
            </div>
          )
          : null
        }
        <div>
          <div className="row" style={{ marginLeft: '10px' }}>
            {
              ((props.actionParam.selectedValue === props.actionParam.rejectedValue)
              && (props.actionParam.selectedReason === -1))
              || (props.actionParam.selectedValue === -1)
              ?
                <button
                  type="submit"
                  name="submit"
                  disabled
                  className="btn green"
                >
                  Submit
                </button>
              : <button type="submit" name="submit" className="btn green">Submit</button>
            }
          </div>
        </div>
      </form>
      )}
    </div>
  </div>
)

FinanceProfileSection.defaultProps = {
  action: null,
  actionParam: {
    orderId: '',
  },
  reference: [],
  dataFinance: {
    reviewedBy: {
      email: '-',
    },
    rejectReason: '-',
    reviewedAt: '-',
  },
}

FinanceProfileSection.propTypes = {
  action: PropTypes.func,
  actionOnChange: PropTypes.func,
  actionOnChangeReason: PropTypes.func,
  actionParam: PropTypes.shape({
    id: PropTypes.string,
    approvedValue: PropTypes.number,
    rejectedValue: PropTypes.number,
    orderId: PropTypes.string,
    selectedValue: PropTypes.number,
    selectedReason: PropTypes.number,
  }),
  reference: PropTypes.arrayOf(PropTypes.object),
  dataFinance: PropTypes.shape({
    id: PropTypes.string,
    reviewedBy: PropTypes.shape({
      email: PropTypes.string,
    }),
    address: PropTypes.string,
    isNotified: PropTypes.bool,
    status: PropTypes.number,
    notified: PropTypes.bool,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    companyLegalName: PropTypes.string,
    taxNumber: PropTypes.string,
    picName: PropTypes.string,
    picPhone: PropTypes.string,
    picEmail: PropTypes.string,
    taxUrl: PropTypes.string,
    rejectReason: PropTypes.number,
    reviewedAt: PropTypes.string,
  }).isRequired,
  onChangeAddress: PropTypes.func.isRequired,
  onSaveAddress: PropTypes.func.isRequired,
  isUpdated: PropTypes.bool.isRequired,
  isUpdatedError: PropTypes.bool.isRequired,
}

export default FinanceProfileSection
